import { useEffect } from 'react';

const GoogleTagManager = () => {
  useEffect(() => {
    // Only load GTM in production environment
    if (process.env.REACT_APP_BRAVEUP_STAGE === 'production') {
      // GTM script injection
      const gtmScript = document.createElement('script');
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-MWF39CH9');
      `;
      document.head.appendChild(gtmScript);

      // GTM noscript fallback
      const gtmNoscript = document.createElement('noscript');
      gtmNoscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MWF39CH9"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.insertBefore(gtmNoscript, document.body.firstChild);

      console.log('Google Tag Manager loaded for production environment');
    } else {
      console.log('Google Tag Manager not loaded - not in production environment');
    }
  }, []);

  return null; // This component doesn't render anything
};

export default GoogleTagManager;
